import React from 'react';
import { ContentTemplate, HeaderTemplate, Stepper, TitleHeader } from 'web-library';

import { useTranslation } from 'react-i18next';
import EditSubject from '../../modules/subject/components/EditSubject';
import ExamDraftMessage from '../../modules/examRegistration/components/ExamDraftMessage';
import ExamTypeUuidDisplay from '../../modules/examRegistration/components/ExamTypeUuidDisplay';

interface SelectSubjectPageProps {
  routeSteps: { label: string }[];
  isGroup?: boolean;
}

const EditSubjectPage = ({ routeSteps, isGroup = false }: SelectSubjectPageProps) => {
  const { t } = useTranslation();

  const title: string = isGroup
    ? t('amendment->>SubjectAmendment.Subject Amendment')
    : 'Subject Amendment';
  const activeStep: number = isGroup ? 1 : 0;

  return (
    <>
      <TitleHeader title={title} />
      <HeaderTemplate>
        {isGroup && <ExamTypeUuidDisplay />}
        <Stepper activeStep={activeStep} steps={routeSteps} />
      </HeaderTemplate>
      <ContentTemplate type="full">
        <EditSubject
          translations={{
            subjectName: t('amendment->>SubjectAmendment.Subject Name'),
            subjectCode: t('amendment->>SubjectAmendment.Subject Code'),
            subjectLevel: t('amendment->>SubjectAmendment.Subject Level'),
            examSeries: t('amendment->>SubjectAmendment.Exam Series'),
            examLevel: t('amendment->>SubjectAmendment.Exam Level'),
            languageMedium: t('amendment->>SubjectAmendment.Language Medium'),
            action: t('amendment->>SubjectAmendment.Action'),
          }}
          isGroup={isGroup}
        />
        <ExamDraftMessage />
      </ContentTemplate>
    </>
  );
};

export default EditSubjectPage;
